import React, {Component} from 'react';
import Control from 'react-leaflet-control';
import {connect} from 'react-redux';
import {error, setActivePoint, setMapCenter} from '../actions';
import {BOTTOM_OF_VICTORIA, LEFT_OF_VICTORIA, RIGHT_OF_VICTORIA, TOP_OF_VICTORIA} from '../Constants.js';
import './CoordinatesControl.css';

class CoordinatesControl extends Component {

  constructor(props) {
    super(props);
    this.state = { isExpanding: false, latlng: null };
  }

  clickEventHanlder = () => {
    if (!this.state.isExpanding) {
      this.setState({
        isExpanding: true,
        latlng: this.props.cursorPoint
      });
      const marker = this.props.mapRef.current.leafletElement;
      if (marker) {
        marker.off('mousemove', this.props.onMouseMoveHandler);
      }
    }
  };

  latChangeEvent = (e) => {
    const value = e.target.value;
    this.setState({ latlng: { lat: value, lng: this.state.latlng.lng } });
  };

  lngChangeEvent = (e) => {
    const value = e.target.value;
    this.setState({ latlng: { lat: this.state.latlng.lat, lng: value } });
  };

  keydownEvent = (e) => {
    if (e.keyCode === 13) {
      // Enter key
      this.handleSubmit();
    } else if (e.keyCode === 27) {
      // Escape key
      this.cancelEdit();
    }
  };

  handleSubmit = () => {
    const { dispatch } = this.props;
    this.cancelEdit();
    const lat = Number(this.state.latlng.lat);
    const lng = Number(this.state.latlng.lng);
    if (lat && lng &&
        lat < TOP_OF_VICTORIA && lat > BOTTOM_OF_VICTORIA &&
        lng > LEFT_OF_VICTORIA && lng < RIGHT_OF_VICTORIA) {
      dispatch(setActivePoint(lat, lng, true, true));
      dispatch(setMapCenter(lat, lng));
    } else {
      dispatch(error('Selected point is not within Victoria'));
    }
  };

  cancelEdit = () => {
    this.setState({ isExpanding: false });
    const marker = this.props.mapRef.current.leafletElement;
    if (marker) {
      marker.on('mousemove', this.props.onMouseMoveHandler);
    }
  };

  render() {
    const { cursorPoint } = this.props;
    return (
      <Control className="leaflet-control-reset leaflet-bar" position="bottomright">
        <div id="coordinate-control" className={this.state.isExpanding ?
                                                'edit-mode' :
                                                ''} onClick={this.clickEventHanlder}>
          <div className="coordinate">
            <div>
              <label>
                Lat:
              </label>
              {!this.state.isExpanding && cursorPoint && cursorPoint.lat}
              {
                this.state.isExpanding &&
                <input value={this.state.latlng ? this.state.latlng.lat : 0}
                       onChange={this.latChangeEvent} onKeyDown={this.keydownEvent}/>
              }
            </div>
          </div>
          <div className="coordinate">
            <div>
              <label>
                Lon:
              </label>
              {!this.state.isExpanding && cursorPoint && cursorPoint.lng}
              {
                this.state.isExpanding &&
                <input value={this.state.latlng ? this.state.latlng.lng : 0}
                       onChange={this.lngChangeEvent} onKeyDown={this.keydownEvent}/>
              }
            </div>
          </div>
          {this.state.isExpanding &&
           <div className="coord-control-buttons">
             <span onClick={this.handleSubmit}><i className="fa fa-check"/></span>
             <span onClick={this.cancelEdit}><i className="fa fa-ban"/></span>
           </div>
          }
        </div>
      </Control>
    );
  }
}

const mapStateToProps = state => {
  return {
    cursorPoint: state.map.cursorPoint
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CoordinatesControl);




// WEBPACK FOOTER //
// ./src/containers/CoordinatesControl.js